// extracted by mini-css-extract-plugin
export default {"textStyles":"SanitizedText_textStyles__8DwiJ"};